import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of, take } from 'rxjs';
import { LeadApiService } from '../api/lead-api.service';
import { ROUTE } from '../constant/route.constant';
import { Helper } from '@portal/util';
import { BizflexFacade } from '../store';

@Injectable({ providedIn: 'root' })
export class LeadReminderGuard implements CanActivate {
  private readonly bizflexFacade = inject(BizflexFacade);
  private readonly router = inject(Router);
  private readonly api = inject(LeadApiService);
  private readonly forbiddenUrlTree$ = of(
    this.router.createUrlTree([ROUTE.ERROR.MAIN, ROUTE.ERROR.FORBIDDEN], { queryParams: { utm_source: 'lead_reminder' } }),
  );

  canActivate(route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> {
    const { TOKEN } = ROUTE.LEAD.QUERY_PARAM;
    const actionToken = route.queryParamMap.get(TOKEN);

    if (typeof actionToken !== 'string') return of(true);

    if (!Helper.validateJwt(actionToken)) {
      return this.forbiddenUrlTree$;
    }

    const payload = Helper.decodeJWT(actionToken);

    if (typeof payload !== 'object' || payload.issuerName !== 'SimpleLeadSubmissionTokenIssuer') {
      return this.forbiddenUrlTree$;
    }

    this.bizflexFacade.setLeadSubmissionToken(actionToken);
    return this.api.detailSubmission().pipe(
      take(1),
      map(() => true),
      catchError(() => this.forbiddenUrlTree$),
    );
  }
}
